import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private tenantId$ = new BehaviorSubject<string | null>(
    localStorage.getItem('activeTenantId')
  );

  getTenantId$() {
    return this.tenantId$.asObservable();
  }

  /** The tenant THIS tab is running with (the localStorage key is shared by all tabs). */
  getTenantId(): string | null {
    return this.tenantId$.value;
  }

  setTenantId(id: string | null) {
    this.tenantId$.next(id);
  }
}
